const setFristChildrenPassportNoExpireDate = (data = null,text = null) => {
  return {
    type: 'SET_FRISTCHILDRENPASSPORTNOEXPIREDATE',
    data,
    text
  }
}

export default {
  setFristChildrenPassportNoExpireDate,
}
